import AppConfig from "config";
import axios from "axios";


const ResultsController = {
  async listLotes(jwtToken, auditId) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `new_results_page/lotes_audit`,
      {
        audit_id: auditId ?? 0
      },
      {
        headers :{
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      }
    );
    return response.data.result;
    } catch(error) {
      console.error("Error fetching lotes:", error);
      throw error;
    }
  },
  async listResults(jwtToken, auditId, dummyValue) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL + `/ficharesults`,
      {
        audit_id: auditId ?? 0,
        lote: dummyValue  ?? ''
      },
      {
        headers :{
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      }
    );
    return response.data;
    } catch(error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
  async refinarResult(jwtToken, auditName, questionName, lote) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL + `/RefinarResultado`,
      {
        audit_name: auditName,
        question_name: questionName,
        lote: lote
      },
      {
        headers :{
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      }
    );
    return response.data;
    } catch(error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
  async rollback(jwtToken, auditName, questionName, lote) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `new_results_page/rollbackrefiner`,
      {
        audit_name: auditName,
        question_name: questionName,
        lote: lote
      },
      {
        headers :{
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      }
    );
    return response.data;
    } catch(error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
  async listaudits(jwtToken) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `results_page/get_audits`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
  async PutAnswer(Id, resposta_resumida, jwtToken) {
    try {
      const response = await axios.put(
        `${AppConfig.BACKEND_URL_REFATORADO}new_results_page/update_answerd/${Id}`,
        { resposta_resumida },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  },      
};

export default ResultsController;
